module.exports = __webpack_public_path__ + "static/media/skateboarding.2fa0cb4d.jpg";